import defaultTo from 'lodash/defaultTo';
import { Currency } from '@atlassian/cssxp-typescommon';

export const minimumFractionDigitsMap: { [key: string]: number } = {
  JPY: 0,
  USD: 2,
};

export const currencyDecimalFormatter: { [key: string]: number } = {
  JPY: 1,
  USD: 100,
};

export const getMinimumFractionDigitsByCurrency = (currency?: string | null) => {
  currency = currency ?? Currency.USD;
  return { minimumFractionDigits: defaultTo(minimumFractionDigitsMap[currency], 2) };
};

export const getFormattedAmountByCurrency = (amount: number, currency?: string | null) => {
  currency = currency || Currency.USD;
  return amount / currencyDecimalFormatter[currency];
};

export const getDenominatorByCurrency = (currency?: string | null) => {
  currency = currency || Currency.USD;
  return currencyDecimalFormatter[currency];
};
